import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import ButtonT3 from '../ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Type } from '../ButtonT3/constants';

import './FormButtonSubmit.scss';

/**
 * @param  {string} theme - Is fed by parent Form
 * @param  {Any} children - Children that will be wrapped in 'ButtonT3'
 * @param  {Bool} isFull - ButtonT3 prop
 * @param  {Any} formik - Provided by formik connect
 */

class FormButtonSubmit extends React.Component {
  static propTypes = {
    theme: PropTypes.string,
    children: PropTypes.any,
    isFull: PropTypes.bool,
    isPillShaped: PropTypes.bool,
    isInverted: PropTypes.bool,
    formik: PropTypes.object,
    onPreSubmit: PropTypes.func,
    qaTag: PropTypes.string,
    name: PropTypes.string,
  };

  static defaultProps = {
    isFull: true,
  };

  render() {
    const { theme, children, isFull, isPillShaped, isInverted, formik, onPreSubmit, qaTag, name } =
      this.props;

    return (
      <div className='FormButtonSubmit'>
        <ButtonT3
          type={ButtonT3Type.SUBMIT}
          theme={theme}
          isFull={isFull}
          isPillShaped={isPillShaped}
          isInverted={isInverted}
          size={ButtonT3Size.LARGE}
          looksDisabled={!formik.isValid}
          onClick={onPreSubmit && onPreSubmit.bind(this, formik)}
          qaTag={qaTag}
          name={name}
        >
          {children}
        </ButtonT3>
      </div>
    );
  }
}

export default formikConnect(FormButtonSubmit);
